import { Component, inject, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ThemeService, Theme } from './shared/services/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgxSpinnerModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  private themeService = inject(ThemeService);
  private router = inject(Router);

  protected readonly title = signal('driveRight');
  protected readonly activeTheme = this.themeService.activeTheme;
  protected readonly isLandingPage = signal(
    ['/', '/terms-and-conditions'].includes(this.router.url.split(/[?#]/)[0]),
  );

  readonly themes: { name: Theme; color: string }[] = [
    { name: 'green', color: '#19c964' },
    { name: 'yellow', color: '#f0a500' },
    { name: 'blue', color: '#3b82f6' },
    { name: 'red', color: '#ef4444' },
  ];

  ngOnInit(): void {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(({ urlAfterRedirects }) => {
        this.isLandingPage.set(
          ['/', '/terms-and-conditions'].includes(urlAfterRedirects.split(/[?#]/)[0]),
        );
        this.themeService.applyRouteTheme(urlAfterRedirects);
      });
  }

  setTheme(theme: Theme): void {
    // Each portal colour routes to its own login screen.
    const destination = theme === 'yellow' ? '/learner/login'
      : theme === 'blue' ? '/driving-school/login'
      : theme === 'red' ? '/vis/login'
      : null;
    this.themeService.setTheme(theme, destination ?? this.router.url);
    if (destination) void this.router.navigateByUrl(destination);
  }
}
